module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.url,
      "readonly": "",
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.log.url),
      callback: function($$v) {
        _vm.$set(_vm.log, "url", $$v)
      },
      expression: "log.url"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.errorMessage,
      "readonly": "",
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.log.errorMessage),
      callback: function($$v) {
        _vm.$set(_vm.log, "errorMessage", $$v)
      },
      expression: "log.errorMessage"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": _vm.$lang.labels.data,
      "readonly": "",
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.log.data),
      callback: function($$v) {
        _vm.$set(_vm.log, "data", $$v)
      },
      expression: "log.data"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.statusCode) + ": " + _vm._s(_vm.log.statusCode) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v(_vm._s(_vm.$lang.labels.created) + ": " + _vm._s(_vm.createdOn) + " ")]), _vm._v(" "), _c('v-layout', [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n        " + _vm._s(_vm.$lang.actions.close) + "\n      ")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27c00e36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/viewLog.vue
// module id = 393
// module chunks = 35